import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import * as moment from 'moment';
import { CancellationReasonsQuery } from '../../queries/cancellation_reasons_query';
import { AppointmentInfoServant } from '../../servants/appointment_info_servant';
import { AppointmentRemindersServant } from '../../servants/appointment_reminders_servant';
import {
  IAppointment,
  IAppointmentCancellationForm,
  IAppointmentCancellationReason,
  IAppointmentDetails
} from '../../types/appointment_interfaces';

export class AppointmentCancelForm extends AppointmentInfoServant {
  private isCancellationPending: boolean = false;
  appointmentDetails: IAppointmentDetails;
  appointment: IAppointment;
  cancellationForm: IAppointmentCancellationForm;
  cancellationComments: string;
  isAppointmentCancelled: boolean;
  closeCancelForm: () => () => void;
  onCancel: () => (cancelForm: any) => void;
  _closeCancelForm: () => void;
  _onCancel: (cancelForm: any) => void;
  isOneTimeAppointment: boolean;
  constructor(
    private $state: angular.ui.IStateService,
    private ngAppointmentRemindersServant: AppointmentRemindersServant,
    private cancelAppointmentCommand: ICommand,
    private loadUpcomingAppointmentsCommand: ICommand,
    private accountModel: any,
    public ngCancellationReasonsQuery: CancellationReasonsQuery,
    private loadCancellationReasonsCommand: ICommand,
    private log: any
  ) {
    super();
    this.initilize();
  }

  get _studentFullName() {
    return `${this.accountModel.firstName} ${this.accountModel.lastName}`;
  }

  $onInit(): any {
    if (this.appointment.student_can_cancel) {
      this.loadCancellationReasonsCommand(this.appointment.appointment_id, this.appointment.calendar_instance_id);
    }
    this.appointmentDetails = this.generateAppointmentDetails(this.appointment, this._studentFullName);
    this._onCancel = this.onCancel();
    this._closeCancelForm = this.closeCancelForm();
    this.isOneTimeAppointment = this.appointment.appointment_type === 'One Time Appointment';
  }

  initilize(): void {
    this.cancellationForm = {
      cancellation_reason: '',
      student_name: this.accountModel.fullname,
      cancellation_reason_id: -1,
      calendar_instance_id: -1,
      comments: '',
      cancelled_date: '',
      cancel_all: false
    };
    this.isAppointmentCancelled = false;
    this.cancellationComments = '';
  }

  reSchedule(): void {
    this.closeCancelForm();
    this.$state.go('my.appointments');
  }

  selectCancellationReason(item: IAppointmentCancellationReason): void {
    this.cancellationForm.cancellation_reason_id = item.id;
    this.cancellationForm.cancellation_reason = item.name;
  }

  setCancellationComments(event: JQueryEventObject): void {
    this.cancellationForm.comments = _4.get(event.target, 'value');
  }

  cancelAll() {
    this.cancellationForm.cancel_all = !this.cancellationForm.cancel_all;
  }

  cancelAppointment(): void {
    if (!this.isCancellationPending) {
      this.isCancellationPending = true;
      this.cancelAppointmentCommand(this.appointment, this.cancellationForm)
        .then(() => {
          this.cancellationForm.cancelled_date = moment().format('MMM DD,YYYY [at] hh:mm A');
          this.isAppointmentCancelled = true;
          this._onCancel({ cancellationForm: this.cancellationForm });
          this.ngAppointmentRemindersServant.trigger.success('Cancelled Appointment.');
          this.loadUpcomingAppointmentsCommand();
          this.isCancellationPending = false;
        })
        .catch((err) => {
          this.log.error(err);
          this.ngAppointmentRemindersServant.trigger.warn('Unable to cancel the Appointment.');
          this.isCancellationPending = false;
        });
    }
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-appointments/src/components/appointment_cancel_form/appointment_cancel_form.ts